"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = require("@mui/material/Grid");
var React = require("react");
var formik_1 = require("formik");
var button_component_1 = require("../../../common/buttons/button_component");
var drop_down_component_1 = require("../../../common/drop_down/drop_down_component");
var text_filed_component_1 = require("../../../common/text_filed/text_filed_component");
var appConstants_1 = require("../../../constants/appConstants");
var array_helpers_1 = require("../../../utils/array_helpers");
var moment = require("moment");
require("./otp_management_styles.scss");
var switch_button_1 = require("../../../common/buttons/switch_button");
var otp_management_api_calls_1 = require("./otp_management_api_calls");
var react_hot_toast_1 = require("react-hot-toast");
var OTPManagement = function () {
    var initialValuesUpdated = {
        applications: []
    };
    var originalOtpStatusesRef = React.useRef([]);
    var _a = React.useState(initialValuesUpdated), initialValues = _a[0], setInitialValues = _a[1];
    var formSubmitHnadler = function (values, setFieldValue, index) {
        var payload = {
            default_otp_status: values.otpStatus,
        };
        if (values.otp !== '') {
            payload['default_otp'] = Number(values.otp);
        }
        else {
            payload['default_otp'] = Number(values.currentOtp);
        }
        if (values.validity && values.validity.value && values.validity.value !== '') {
            payload['default_otp_expiry'] = values.validity.value;
        }
        else {
            payload['default_otp_expiry'] = values.currentOTPExpiry;
        }
        if (values.otp && values.validity === '') {
            react_hot_toast_1.default.error('Please select validity');
        }
        else {
            (0, otp_management_api_calls_1.submitOtp)(payload, values.id)
                .then(function (response) {
                if (response.status === 200) {
                    setFieldValue("applications.".concat(index, ".reGenerate"), false);
                    originalOtpStatusesRef.current[index] = false;
                    setFieldValue("applications.".concat(index, ".isStatusUpdated"), false);
                    if (values.otp !== '') {
                        setFieldValue("applications.".concat(index, ".currentOtp"), values.otp);
                    }
                    if (values.validity && values.validity.value && values.validity.value !== '') {
                        setFieldValue("applications.".concat(index, ".currentOTPExpiry"), values.validity.value);
                    }
                }
            });
        }
    };
    var cancelHandler = function (setFieldValue, index) {
        setFieldValue("applications.".concat(index, ".reGenerate"), false);
        setFieldValue("applications.".concat(index, ".validity"), '');
        setFieldValue("applications.".concat(index, ".otp"), '');
    };
    var generateOTP = function (setFieldValue, index) {
        var newOTP = Math.floor(1000 + Math.random() * 9000).toString();
        setFieldValue("applications.".concat(index, ".otp"), newOTP);
        setFieldValue("applications.".concat(index, ".reGenerate"), true);
    };
    var validatyOnchangeHandler = function (setFieldValue, validity, index) {
        var validityPeriod = validity.label.toLowerCase();
        var futureDate = moment();
        if (validityPeriod.includes('day')) {
            var days = parseInt(validityPeriod) || 1;
            futureDate = futureDate.add(days, 'days');
            validity['value'] = futureDate.format('YYYY-MM-DD');
        }
        else if (validityPeriod.includes('week')) {
            var weeks = parseInt(validityPeriod) || 1;
            futureDate = futureDate.add(weeks, 'weeks');
            validity['value'] = futureDate.format('YYYY-MM-DD');
        }
        else if (validityPeriod.includes('month')) {
            var months = parseInt(validityPeriod) || 1;
            futureDate = futureDate.add(months, 'months');
            validity['value'] = futureDate.format('YYYY-MM-DD');
        }
        else {
            validity['value'] = '';
        }
        setFieldValue("applications.".concat(index, ".validity"), validity);
    };
    var fetchAvailableApps = function (isMounted) {
        (0, otp_management_api_calls_1.fetchLogisticsApps)()
            .then(function (response) {
            if (!isMounted)
                return;
            var convertedResponse = (0, array_helpers_1.convertAppListResponse)(response.data.result);
            var updatedInitialvalues = {
                applications: convertedResponse.length > 0 ?
                    convertedResponse.map(function (app) { return ({
                        applicationType: app.label,
                        currentOtp: app.otp,
                        currentOTPExpiry: app.otp_expiry,
                        otpStatus: app.otp_status === 0 ? false : true,
                        otp: '',
                        validity: '',
                        id: app.id,
                        reGenerate: false,
                        isStatusUpdated: false
                    }); }) : []
            };
            setInitialValues(updatedInitialvalues);
            originalOtpStatusesRef.current = convertedResponse.map(function (app) { return app.otp_status === 0 ? false : true; });
        })
            .catch(function (err) {
            if (isMounted) {
                console.log(err);
            }
        });
    };
    React.useEffect(function () {
        var isMounted = true;
        fetchAvailableApps(isMounted);
        return function () {
            isMounted = false;
        };
    }, []);
    return (React.createElement(formik_1.Formik, { key: JSON.stringify(initialValues), initialValues: __assign({}, initialValues), validateOnBlur: false, enableReinitialize: true, onSubmit: function () { } }, function (_a) {
        var errors = _a.errors, values = _a.values, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched, touched = _a.touched;
        return (React.createElement(formik_1.Form, { id: "myForm", className: "input-fileds-wrapper" },
            React.createElement("div", { className: "tool-bar-wrapper border-bottom no-filter-toolbar" },
                React.createElement("div", { className: "page-heaidng heading-return-wrapper" },
                    React.createElement("h2", null, "OTP Management"))),
            React.createElement(formik_1.FieldArray, { name: "applications" }, function (_a) {
                var remove = _a.remove;
                return (React.createElement(Grid_1.default, { container: true, className: 'otp-form-wrapper' }, values.applications && values.applications.length > 0 ? (values.applications.map(function (appdata, index) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                    return (React.createElement("div", { className: "full-grid-scroll-wrapper" },
                        React.createElement(Grid_1.default, { container: true, xs: 12, key: index, className: 'section-wrapper' },
                            React.createElement(Grid_1.default, { item: true, xs: 10 },
                                React.createElement(Grid_1.default, { item: true, xs: 12 },
                                    React.createElement(Grid_1.default, { container: true, columnSpacing: 3 },
                                        React.createElement(Grid_1.default, { item: true, xs: 3 },
                                            React.createElement(text_filed_component_1.default, { name: "applications.".concat(index, ".applicationType"), placeholder: "Application", label: 'Application Type', value: appdata.applicationType || appdata.label, isDisabled: true })),
                                        React.createElement(Grid_1.default, { item: true, xs: 2 },
                                            React.createElement(text_filed_component_1.default, { name: "applications.".concat(index, ".currentOtp"), placeholder: "Current OTP", label: "Current OTP", value: appdata.currentOtp || appdata.otp, isDisabled: true })),
                                        React.createElement(Grid_1.default, { item: true, xs: 3 },
                                            React.createElement(text_filed_component_1.default, { name: "applications.".concat(index, ".currentOTPExpiry"), placeholder: "Current OTP Expiry Date", label: "Current OTP Expiry Date", value: appdata.currentOTPExpiry || appdata.otp_expiry, isDisabled: true })),
                                        React.createElement(Grid_1.default, { item: true, xs: 4, style: { alignSelf: 'center' } },
                                            React.createElement(switch_button_1.default, { swicthLabel: 'Enable/disable Default OTP :', value: appdata.otpStatus, defaultChecked: appdata.otpStatus, name: "applications.".concat(index, ".otpStatus"), parentClass: 'switch-button-wrapper-responsive', onChangeHandler: function (event) {
                                                    var _a;
                                                    var newStatus = event.target.checked;
                                                    setFieldValue("applications.".concat(index, ".otpStatus"), newStatus);
                                                    var originalStatus = (_a = originalOtpStatusesRef.current) === null || _a === void 0 ? void 0 : _a[index];
                                                    var isUpdated = newStatus !== originalStatus;
                                                    setFieldValue("applications.".concat(index, ".isStatusUpdated"), isUpdated);
                                                } }),
                                            ((_b = (_a = errors.applications) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.otpStatus) &&
                                                ((_d = (_c = touched.applications) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.otpStatus) ? (React.createElement("div", { className: "error" }, errors.applications[index].otpStatus)) : null))),
                                (values === null || values === void 0 ? void 0 : values.applications[index].reGenerate) &&
                                    React.createElement(Grid_1.default, { item: true, xs: 12 },
                                        React.createElement(Grid_1.default, { container: true, columnSpacing: 3 },
                                            React.createElement(Grid_1.default, { item: true, xs: 3, className: 'button-grid-wrapper' },
                                                React.createElement(button_component_1.default, { buttonName: 'Re-Generate OTP', color: "blue", onClickHandler: function () { return generateOTP(setFieldValue, index); } })),
                                            React.createElement(Grid_1.default, { item: true, xs: 2, style: { alignSelf: 'center' } },
                                                React.createElement(text_filed_component_1.default, { name: "applications.".concat(index, ".otp"), placeholder: "OTP", label: "Generated OTP", value: appdata.otp, isDisabled: true }),
                                                ((_f = (_e = errors.applications) === null || _e === void 0 ? void 0 : _e[index]) === null || _f === void 0 ? void 0 : _f.otp) &&
                                                    ((_h = (_g = touched.applications) === null || _g === void 0 ? void 0 : _g[index]) === null || _h === void 0 ? void 0 : _h.otp) ? (React.createElement("div", { className: "error" }, errors.applications[index].otp)) : null),
                                            React.createElement(Grid_1.default, { item: true, xs: 3 },
                                                React.createElement(drop_down_component_1.default, { dropDownList: appConstants_1.otpValidations || [], placeholder: "Select Validity", required: true, value: appdata.validity, onChange: function (val) { return validatyOnchangeHandler(setFieldValue, val, index); } }),
                                                ((_k = (_j = errors.applications) === null || _j === void 0 ? void 0 : _j[index]) === null || _k === void 0 ? void 0 : _k.validity) &&
                                                    ((_m = (_l = touched.applications) === null || _l === void 0 ? void 0 : _l[index]) === null || _m === void 0 ? void 0 : _m.validity) ? (React.createElement("div", { className: "error" }, errors.applications[index].validity)) : null),
                                            React.createElement(Grid_1.default, { item: true, xs: 3, sx: { marginTop: '12px' } },
                                                React.createElement(text_filed_component_1.default, { name: "applications.".concat(index, ".validity"), placeholder: "Valid Upto", label: "Valid Upto", value: appdata.validity.value, isDisabled: true }))))),
                            (values === null || values === void 0 ? void 0 : values.applications[index].reGenerate) && (React.createElement(Grid_1.default, { item: true, xs: 12, md: 2, style: { alignSelf: 'center' } },
                                React.createElement(Grid_1.default, { container: true, direction: { xs: 'column', md: 'row' }, spacing: 2, justifyContent: "center", alignItems: "center" },
                                    React.createElement(Grid_1.default, { item: true },
                                        React.createElement(button_component_1.default, { type: "button", buttonName: "Cancel", color: "yellow-outline", onClickHandler: function () { return cancelHandler(setFieldValue, index); } })),
                                    React.createElement(Grid_1.default, { item: true },
                                        React.createElement(button_component_1.default, { buttonName: "Update", color: "yellow", isError: false, onClickHandler: function () { return formSubmitHnadler(appdata, setFieldValue, index); } }))))),
                            !(values === null || values === void 0 ? void 0 : values.applications[index].reGenerate) && (React.createElement(Grid_1.default, { item: true, xs: 12, md: 2, style: { alignSelf: 'center' } },
                                React.createElement(Grid_1.default, { container: true, direction: { xs: 'column', md: 'row' }, spacing: 2, justifyContent: "center", alignItems: "center" },
                                    React.createElement(Grid_1.default, { item: true, className: 'button-grid-wrapper' },
                                        React.createElement(button_component_1.default, { buttonName: "Re-Generate OTP", color: "blue", onClickHandler: function () { return generateOTP(setFieldValue, index); } })),
                                    appdata.isStatusUpdated && (React.createElement(Grid_1.default, { item: true },
                                        React.createElement(button_component_1.default, { buttonName: "Update", color: "yellow", isError: false, onClickHandler: function () { return formSubmitHnadler(appdata, setFieldValue, index); } })))))))));
                })) : (React.createElement(Grid_1.default, { item: true, xs: 12 },
                    React.createElement("div", { style: { textAlign: 'center', padding: '20px' } }, "No applications available")))));
            })));
    }));
};
exports.default = OTPManagement;
